import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

const Hero = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <section className="relative overflow-hidden bg-background">
      <div className="container mx-auto px-4 py-20 md:py-28 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-3xl mx-auto text-center"
        >
          <h1 className="text-4xl md:text-6xl font-extralight text-foreground leading-[1.15] tracking-tight">
            {t("hero.title")}{" "}
            <span className="italic">{t("hero.titleItalic")}</span>
          </h1>
          <p className="mt-6 text-base md:text-lg font-light text-muted-foreground max-w-xl mx-auto leading-relaxed">
            {t("hero.subheadline")}
          </p>
          <div className="mt-10 flex justify-center">
            <Button
              size="lg"
              className="bg-primary text-primary-foreground hover:bg-primary/85 rounded-full px-10 text-sm font-light tracking-wide gap-2 shadow-none"
              onClick={() => navigate("/create")}
            >
              {t("hero.cta", "Start now")}
              <ArrowRight size={16} strokeWidth={1.5} />
            </Button>
          </div>
          <p className="mt-6 text-xs font-light text-muted-foreground tracking-wide">
            {t("hero.micro")}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
